import { render, staticRenderFns } from "./indexbyProduct.vue?vue&type=template&id=5cb1b7bd&scoped=true"
import script from "./indexbyProduct.vue?vue&type=script&lang=js"
export * from "./indexbyProduct.vue?vue&type=script&lang=js"
import style0 from "./indexbyProduct.vue?vue&type=style&index=0&id=5cb1b7bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb1b7bd",
  null
  
)

export default component.exports